import React from 'react'
import { footerImage } from '../../images/svg'

const Footer = ({ footer = {} }) => {
  return (
    <footer id="main-content">
      <div className="container">
        <section className="footer">
          <h2 className="visually-hidden">Footer</h2>
          <div className="footer-top">
            <div className="content-container">
              <div className="footer--column">
                <div className="gentinfo-block">
                  <figure className="gentinfo-logo-custom">
                    {footerImage}
                  </figure>
                  <div className="gentinfo-block-content">
                    <h2
                      dangerouslySetInnerHTML={{ __html: footer.contact_title }}
                    />
                    <p
                      dangerouslySetInnerHTML={{
                        __html: footer.contact_paragraph,
                      }}
                    />

                    <ul className="icon-list ">
                      <li
                        dangerouslySetInnerHTML={{
                          __html: `<i
                          class="span-icon icon-phone"
                          aria-hidden="true"
                          title="Phone"
                        ></i>${footer.contact_no}`,
                        }}
                      />
                      <li
                        dangerouslySetInnerHTML={{
                          __html: `<i
                          class="span-icon icon-envelope"
                          aria-hidden="true"
                          title="Envelope"
                          ></i>${footer.contact_email}`,
                        }}
                      />

                      <li
                        dangerouslySetInnerHTML={{
                          __html: `<i
                          class="span-icon icon-url"
                          aria-hidden="true"
                          title="Icon URL"
                          ></i>${footer.contact_url}`,
                        }}
                      />
                    </ul>
                  </div>
                </div>
              </div>

              <div className="footer--column">
                <div
                  className="dg-block-disclaimer"
                  dangerouslySetInnerHTML={{ __html: footer.disclaimer_list }}
                />
              </div>
              <div className="footer--column">
                <div className="dg-block-post-address">
                  <h3
                    dangerouslySetInnerHTML={{ __html: footer.social_title }}
                  />
                  <div className="social-list">
                    <ul className="">
                      <li>
                        <a href={footer.icon_1_link}>
                          <i
                            aria-hidden="true"
                            className="icon-facebook"
                            title="Facebook"
                          />
                          <span className="visually-hidden">
                            {footer.icon_1_text}
                          </span>
                        </a>
                      </li>
                      <li>
                        <a href={footer.icon_2_link}>
                          <i
                            aria-hidden="true"
                            className="icon-instagram"
                            title="Instagram"
                          />
                          <span className="visually-hidden">
                            {footer.icon_2_text}
                          </span>
                        </a>
                      </li>
                      <li>
                        <a href={footer.icon_3_link}>
                          <i
                            aria-hidden="true"
                            className="icon-linkedin"
                            title="LinkedIn"
                          />
                          <span className="visually-hidden">
                            {footer.icon_3_text}
                          </span>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="footer-bottom content-container">
            <div
              className="footer--column"
              dangerouslySetInnerHTML={{ __html: footer.bottom_list }}
            />

            <div className="footer--column partnership">
              <span>In samenwerking met District09</span>
              <i aria-hidden="true" className="icon-district09" />
            </div>
          </div>
        </section>
      </div>
    </footer>
  )
}
export default Footer
